import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Rows",
  "use": "Rows-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"Rows\"><path fill=\"currentColor\" d=\"M0 0h24v5.053H0zm0 12.632h24v5.053H0zm0 6.315h24V24H0zM0 6.316h24v5.053H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol